module.exports = __webpack_public_path__ + "img/thumbnail_GalapagosGiantTortoise_f_normal.2531377c.png";